import { useUIStore } from "@app/store";
import { OverviewPage } from "@shared/components/layout";
import { Label } from "@shared/components/atoms/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@shared/components/atoms/select";
import { ViewToggle } from "@shared/components/widgets";
import { useLanguage, useTranslation } from "@shared/locales";
import type { LanguageTypes } from "@shared/locales";

export function Settings() {
  const { t } = useTranslation();
  const { language, setLanguage } = useLanguage();
  const { collectionViewMode, setCollectionViewMode } = useUIStore();

  return (
    <OverviewPage
      title={t("settings.title")}
      content={
        <div className="space-y-6">
          <div className="rounded-lg border border-border bg-card p-6">
            <h2 className="mb-4 text-lg font-semibold">
              {t("settings.language.sectionTitle")}
            </h2>
            <div className="flex flex-col gap-2">
              <Label htmlFor="language-select">
                {t("settings.language.label")}
              </Label>
              <Select
                value={language}
                onValueChange={(value) =>
                  void setLanguage(value as LanguageTypes)
                }
              >
                <SelectTrigger id="language-select" className="w-64">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="en">
                    {t("settings.language.en")}
                  </SelectItem>
                  <SelectItem value="de">
                    {t("settings.language.de")}
                  </SelectItem>
                  <SelectItem value="ar">
                    {t("settings.language.ar")}
                  </SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>

          <div className="rounded-lg border border-border bg-card p-6">
            <h2 className="mb-4 text-lg font-semibold">
              {t("settings.view.sectionTitle")}
            </h2>
            <div className="flex flex-col gap-2">
              <Label>{t("settings.view.label")}</Label>
              <ViewToggle
                value={collectionViewMode}
                onChange={setCollectionViewMode}
              />
            </div>
          </div>
        </div>
      }
    />
  );
}
